import type { ReactNode, FC } from 'react';

import { Section } from '@xing-com/layout-primitives';

import {
  StyledHeader,
  StyledHeaderPlacebo,
  StyledHeaderWrapper,
  StyledLogoDesktop,
  StyledLogoWrapper,
} from './header-minimal.styles';

const HeaderLogo: FC = () => {
  return (
    <StyledLogoWrapper>
      <StyledLogoDesktop dataTestId="logo" />
    </StyledLogoWrapper>
  );
};

export type HeaderMinimalProps = React.PropsWithChildren<{
  className?: string;
  preChildren?: ReactNode | undefined;
  showOnSmallerScreens: boolean;
}>;

export const HeaderMinimal: React.FC<HeaderMinimalProps> = ({
  children,
  className,
  preChildren,
  showOnSmallerScreens,
}) => {
  return (
    <StyledHeaderPlacebo
      $showOnSmallerScreens={showOnSmallerScreens}
      className={className}
    >
      <StyledHeaderWrapper>
        {preChildren}
        <Section noBlockPadding>
          <StyledHeader>
            <HeaderLogo />
            {children}
          </StyledHeader>
        </Section>
      </StyledHeaderWrapper>
    </StyledHeaderPlacebo>
  );
};
